<template>
  <section
    class="info-card d-flex flex-column"
    :class="isMobile ? 'gr-4' : 'gr-6 pa-6 elevation-1 rounded-sm'"
  >
    <a
      v-if="adminkaUrl"
      :href="adminkaUrl"
      class="adminka align-self-start"
      target="_blank"
      rel="noopener noreferrer"
    >{{ t('править', options) }}</a>
    <h2 class="text-h6 text--text">
      {{ title }}
    </h2>
    <slot>
      <div
        ref="htmlContainer"
        class="info-card__html d-flex flex-column gr-3 text-body-2 text--text"
        :class="{ 'info-card__html--collapsed': !isExpanded && needExpand }"
        v-html="textHtml/* eslint-disable-line vue/no-v-html */"
      />
      <button
        v-if="truncated && needExpand && !isExpanded"
        type="button"
        class="info-card__read-more text-body-2 link-decoration-underline primary--text"
        @click="isExpanded = true"
      >
        {{ t('Читать полностью', options) }}
      </button>
    </slot>
  </section>
</template>

<script lang="ts" setup>
import type { ContextStore } from 'src/components/pages/info/about-us/index/types'
import I18NextVue from 'i18next'
import { useContextStore } from 'src/store'
import {
  computed, ref, watch, onMounted, nextTick,
} from 'vue'

const { t, language } = I18NextVue
const options = { ns: language }

const MAX_HEIGHT = 500

const props = defineProps<{
  title: string
  textHtml?: string
  adminkaUrl?: string
  truncated?: boolean
}>()

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context?.flavour === 'mobile')

const htmlContainer = ref<HTMLElement | null>(null)
const isExpanded = ref(false)
const needExpand = ref(false)

function checkHeight() {
  nextTick(() => {
    if (htmlContainer.value) {
      needExpand.value = !!props.truncated && htmlContainer.value.scrollHeight > MAX_HEIGHT

      if (needExpand.value) {
        isExpanded.value = false
      }
    }
  })
}

onMounted(checkHeight)
watch(() => props.textHtml, checkHeight)
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/typography';

.info-card {
  &__html {
    & > :deep(*) {
      margin-bottom: 0 !important;
    }

    & > :deep(ul),
    & > :deep(ol) {
      display: flex;
      flex-direction: column;
      row-gap: 12px;
      list-style-type: none;
    }

    & > :deep(b) {
      font-weight: $weight-medium;
    }

    & > :deep(b ~ span) {
      margin-top: -12px; // Компенсирует gr-3
    }

    &--collapsed {
      overflow: hidden;
      max-height: 500px;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 70%;
        max-height: 90px;
        min-height: 50px;
        pointer-events: none;
        background: linear-gradient(0deg, #FFFFFF, transparent 100%);
      }
    }
  }

  &__read-more {
    align-self: start;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    text-decoration: underline;
  }
}
</style>
